import { render, staticRenderFns } from "./MPopupConfirmDelete.vue?vue&type=template&id=0c3fb068&"
import script from "./MPopupConfirmDelete.ts?vue&type=script&lang=ts&"
export * from "./MPopupConfirmDelete.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports